import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import {
	MacroContentRendererQueryWithTags,
	MacroBodyRendererQueryWithTags,
} from '@confluence/fabric-extension-queries/entry-points/MacroContentRendererQueryWithTags.graphql.ts';

export function preloadMacrosSPA() {
	const macroParams: any[] = window['__LEGACY_MACRO_PARAMS__'] || [];
	window['__LEGACY_MACRO_PARAMS__'] = [];

	// eslint-disable-next-line check-preloaders/no-promise-all
	return Promise.all(
		macroParams.map(({ isMacroContentAndBody, ...rest }) => {
			const preloadMacroQuery = isMacroContentAndBody
				? MacroBodyRendererQueryWithTags
				: MacroContentRendererQueryWithTags;

			return query({
				/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
				query: preloadMacroQuery,
				variables: rest,
				context: { single: true },
			});
		}),
	);
}
